import { render } from "./AppHero.vue?vue&type=template&id=59cabf12"
import script from "./AppHero.vue?vue&type=script&lang=js"
export * from "./AppHero.vue?vue&type=script&lang=js"

import exportComponent from "/Users/davecalleja/experiments/playnova-beta/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__